
$(document).ready(function () {
    //PAGE TO SCROLL SCRIPT START
    var hashLocation = false;
    if (location.hash) {
        hashLocation = window.location.hash;
        setTimeout(function () {
            hashLocation = window.location.hash;
        }, 1);
    }
    if (hashLocation) {
        setTimeout(function () {
            if (hashLocation.indexOf('_hash') < 0) {
                hashLocation = hashLocation;
            };
            // Scroll to target
            $('html,body').animate({
                scrollTop: $(hashLocation).offset().top - 150
            });

        }, 100);

    };

    $('.scroll-goal,.explore-tool a').on('click', function () {
        var target = $(this.hash);
        $('html, body').animate({
            scrollTop: target.offset().top - 100
        }, 1000);
    });

    $('.cities-details-list li a,.scroll-to-link a').on('click', function () {
        var target = $(this.hash);
        $('html, body').animate({
            scrollTop: target.offset().top - 150
        }, 1000);
    });
    //PAGE TO SCROLL SCRIPT END
});
